export * from "@vaadin/checkbox/vaadin-checkbox.js";
export * from './generated/Checkbox.js';
